import React from 'react';
import { JcUtils } from '../utils/JcUtils';
import { JcBoxProps, JcColumn } from './JcBox';

export interface JcPlaceholderProps extends Omit<JcBoxProps, "flexGrow | alignCenter | justifyCenter"> { }

export const JcPlaceholder: React.FunctionComponent<JcPlaceholderProps> = (props: JcPlaceholderProps) => {
    const commonProps = JcUtils.commonProps(props, ["jc-placeholder"]);
    const boxProps = JcUtils.otherProps(props);
    return <JcColumn {...commonProps} {...boxProps} flexGrow alignCenter justifyCenter />
}
